import { AFrameScene } from '../lib/aframe-components'
import { FloatingBackButton } from '../lib/material-ui-components'
import { createSceneHtml, createSceneHtmlAsync } from './model-config'
import { getExperienceConfig, experienceExists } from '../lib/experience-routes'
import './main.css'

declare let React: any
declare let ReactRouterDOM: any

const { withRouter } = ReactRouterDOM

interface AnimationParams {
    animation?: string
    repeat?: string
    listAnim?: string
    text?: string
}

// Componente pubblico per visualizzare esperienze 3D senza token/autenticazione.
// Accede tramite URL: /demo/:experienceId
// Identico a ExperienceViewer ma bypasssa ProtectedRoute.
const PublicExperienceViewer = withRouter(({ match, location, history }: any) => {
    const [sceneHtml, setSceneHtml] = React.useState('')
    const [isLoading, setIsLoading] = React.useState(true)
    const [error, setError] = React.useState(null)

    // L'experienceId arriva direttamente da match.params (nessuna funzione di parsing path)
    const experienceId: string = match.params.experienceId

    // Estrai parametri dall'URL query string
    const urlParams = new URLSearchParams(location.search)
    const customParams: Record<string, string> = {}
    urlParams.forEach((value, key) => {
        customParams[key] = value
    })

    // Verifica se l'esperienza esiste nel registro
    if (!experienceId || !experienceExists(experienceId)) {
        return (
            <div style={{ padding: '20px', textAlign: 'center' }}>
                <h2>Esperienza non trovata</h2>
                <p>L'esperienza "{experienceId || 'ID mancante'}" non è disponibile.</p>
                <p>Esperienze disponibili: generic, castel-oggi, castel-ieri, bleirot, forno, ...</p>
            </div>
        )
    }

    React.useEffect(() => {
        const loadScene = async () => {
            try {
                setIsLoading(true)
                setError(null)

                const experienceConfig = getExperienceConfig(experienceId, customParams)

                console.log(`🌐 [PUBLIC] Caricamento esperienza pubblica: ${experienceId}`)
                console.log(`📋 Configurazione:`, experienceConfig)

                const animationParams: AnimationParams = {}
                if (experienceConfig.customParams.animation) {
                    animationParams.animation = experienceConfig.customParams.animation
                    animationParams.repeat = experienceConfig.customParams.repeat
                    animationParams.listAnim = experienceConfig.customParams.listAnim
                    animationParams.text = experienceConfig.customParams.text
                }

                const finalCustomParams = {
                    ...experienceConfig.customParams,
                    ...animationParams
                }

                const asyncSceneHtml = await createSceneHtmlAsync(
                    experienceConfig.modelType,
                    finalCustomParams,
                    experienceId
                )

                setSceneHtml(asyncSceneHtml)
                console.log(`✅ [PUBLIC] Scena HTML generata per ${experienceConfig.modelType}`)

            } catch (err: any) {
                console.error('❌ [PUBLIC] Errore nel caricamento:', err)
                setError(err.message || 'Errore sconosciuto')

                // Fallback sincrono
                try {
                    const experienceConfig = getExperienceConfig(experienceId, customParams)
                    const animationParams: AnimationParams = {}
                    if (experienceConfig.customParams.animation) {
                        animationParams.animation = experienceConfig.customParams.animation
                        animationParams.repeat = experienceConfig.customParams.repeat
                        animationParams.listAnim = experienceConfig.customParams.listAnim
                        animationParams.text = experienceConfig.customParams.text
                    }

                    const fallbackSceneHtml = createSceneHtml(experienceConfig.modelType, {
                        ...experienceConfig.customParams,
                        ...animationParams
                    })

                    setSceneHtml(fallbackSceneHtml)
                    setError(null)
                    console.log(`🔄 [PUBLIC] Fallback sincrono completato`)
                } catch (fallbackError: any) {
                    console.error('❌ [PUBLIC] Errore anche nel fallback:', fallbackError)
                    setError('Impossibile caricare l\'esperienza')
                }
            } finally {
                setIsLoading(false)
            }
        }

        loadScene()
    }, [experienceId])

    if (isLoading) {
        return (
            <div style={{ padding: '20px', textAlign: 'center' }}>
                <h2>Caricamento...</h2>
                <p>Preparazione esperienza "{experienceId}"</p>
            </div>
        )
    }

    if (error && !sceneHtml) {
        return (
            <div style={{ padding: '20px', textAlign: 'center' }}>
                <h2>Errore nel caricamento</h2>
                <p>{error}</p>
            </div>
        )
    }

    if (sceneHtml) {
        return (
            <React.Fragment>
                <FloatingBackButton />
                <AFrameScene sceneHtml={sceneHtml} />
            </React.Fragment>
        )
    }

    return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <h2>Errore nel caricamento</h2>
            <p>Impossibile generare la scena.</p>
        </div>
    )
})

export { PublicExperienceViewer }
